// extracted by mini-css-extract-plugin
export default {"container":"team_container__YQ6Br","title":"team_title__oC4Bp","summary":"team_summary__fxRgi"};